export enum SubscriptionStatus {
  INCOMPLETE = "INCOMPLETE",
  ACTIVE = "ACTIVE",
  PAST_DUE = "PAST_DUE",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  SUPERSEDED = "SUPERSEDED",
}

// Keep internal statuses out of the selectable list.
export const LISTABLE_SUBSCRIPTION_STATUSES = [
  SubscriptionStatus.ACTIVE,
  SubscriptionStatus.PAST_DUE,
  SubscriptionStatus.INCOMPLETE,
  SubscriptionStatus.CANCELED,
  SubscriptionStatus.COMPLETED,
];

export enum SubscriptionChargeStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
}

export enum SubscriptionCanceledBy {
  PAYER = "PAYER",
  MERCHANT = "MERCHANT",
  PAYMENT_FAILED = "PAYMENT_FAILED",
}

export enum DeclineClass {
  RETRYABLE = "RETRYABLE",
  HARD_DECLINE = "HARD_DECLINE",
}
